import cn from 'clsx';
import PlayroomRewardCardSkeleton from "../PlayroomRewardCardSkeleton";
import { jsx as _jsx } from "react/jsx-runtime";
var PlayroomMarketplaceEmptyState = function PlayroomMarketplaceEmptyState(_ref) {
  var maxItems = _ref.maxItems,
    animated = _ref.animated,
    className = _ref.className,
    style = _ref.style;
  var maxItemsArray = Array.from({
    length: maxItems
  });
  return /*#__PURE__*/_jsx("section", {
    "data-testid": "playroom-marketplace-loading",
    className: cn('tw-w-full',
    // Grid
    'tw-grid tw-gap-1.2 tw-grid-cols-1 sm:tw-grid-cols-2', className),
    style: style,
    children: maxItemsArray.map(function (_, index) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _jsx(PlayroomRewardCardSkeleton, {
          animated: animated
        }, index + 1)
      );
    })
  });
};
export default PlayroomMarketplaceEmptyState;